export function toEnumFromValue<T>(mapping: any, value: string): T {
  let values = Object.keys(mapping).map((key) => mapping[key]);
  if (
    values.find((v: string | number) => v.toString() === value) === undefined
  ) {
    throw new Error(
      `Missing value "${value}" in enum. Available keys are ${values.join(
        ', ',
      )}`,
    );
  }
  if (value in mapping) {
    // For string to number convertion
    return mapping[mapping[value]];
  }
  return value as any as T;
}

export function toEnumType<T, TYPE>(value: T, mapping: any): TYPE {
  if (!((value as any) in mapping)) {
    throw new Error(
      `Missing mapping for ${value}. Available: ${Object.keys(mapping).join(
        ', ',
      )}`,
    );
  }
  return mapping[value];
}

// export function toEnumFromKey<T>(mapping: any, key: string): T {
//     if (!(key in mapping)) {
//         throw new Error(`Missing key "${key}" in enum. Available keys are ${Object.keys(mapping).join(', ')}`);
//     }
//     return mapping[mapping[key]];
// }
